module.exports = __webpack_public_path__ + "img/box-ballot.7ef3aec5.svg";